import Swal from 'sweetalert2';

export class NotificationService {
  static showValidationSingleError(msg) {
    return Swal.fire({
      title: 'Ops...',
      position: 'center',
      allowEscapeKey: false,
      allowOutsideClick: false,
      showConfirmButton: true,
      html: msg,
      heightAuto: false,
      confirmButtonColor: '#A9A9A9',
    });
  }

  static showValidationError(errors) {
    const errorsLi = errors.map((e) => `${e} <br/>`).join('');
    Swal.fire({
      title: 'Ops...',
      position: 'center',
      showConfirmButton: true,
      allowEscapeKey: false,
      allowOutsideClick: false,
      html: errorsLi,
      heightAuto: false,
      confirmButtonColor: '#A9A9A9',
    });
  }

  static showConfirm(msg, confirmButtonText, confirmDenyButtonText) {
    return Swal.fire({
      html: msg,
      showCancelButton: true,
      confirmButtonText: confirmButtonText,
      confirmButtonColor: '#A9A9A9',
      cancelButtonText: confirmDenyButtonText,
      cancelButtonColor: '#A9A9A9',
      allowEscapeKey: false,
      allowOutsideClick: false,
      heightAuto: false,
    });
  }

  static showConfirmWithTitle(
    title,
    msg,
    confirmButtonText,
    confirmDenyButtonText,
  ) {
    return Swal.fire({
      title: title,
      html: msg,
      showCancelButton: true,
      confirmButtonText: confirmButtonText,
      confirmButtonColor: '#A9A9A9',
      cancelButtonText: confirmDenyButtonText,
      cancelButtonColor: '#A9A9A9',
      allowEscapeKey: false,
      allowOutsideClick: false,
      heightAuto: false,
    });
  }

  static showMessageWithoutButton(msg) {
    return Swal.fire({
      html: msg,
      allowOutsideClick: false,
      allowEscapeKey: false,
      showCloseButton: false,
      showConfirmButton: false,
      confirmButtonColor: '#A9A9A9',
      heightAuto: false,
    });
  }

  static showTerms(msg) {
    return Swal.fire({
      html: msg,
      grow: 'row',
      allowOutsideClick: false,
      allowEscapeKey: false,
      showCloseButton: true,
      showConfirmButton: false,
      confirmButtonColor: '#A9A9A9',
      heightAuto: false,
      customClass: {
        popup: 'swal2-popup-custom',
        closeButton: 'swal2-close-custom',
      },
    });
  }
}
